import * as Html from "../../util/Html.ts";
export {initDom}
Html.registerWidget('widget/form/onoff',{initDom:initDom})

function initDom(elem: HTMLElement){
  const input = elem.querySelector('input') as HTMLInputElement;
  if(!input) return;

  elem.addEventListener('click', function(evt){
    if(!input.disabled){
      const newValue = input.value !== 'true';
      input.value = String(newValue);
      input.dispatchEvent(new Event('change'));

      const onchangeAttr = input.getAttribute('data-fw-onchange');
      if(onchangeAttr){
        Html.trigger(input, onchangeAttr);
      }
    }
  });

  function updateClasses(){
    elem.classList.toggle('fw-onoff-disabled', input.disabled);
    elem.classList.toggle('fw-onoff-on', input.value === 'true');
  }

  // Écouter les deux événements
  input.addEventListener('change', updateClasses);
  input.addEventListener('ui-change', updateClasses);
}